import {
  fetchActivityByOperationId,
  selectFreezerActivityByOperationId,
} from "@app/freezer";
import { useQuery, useSelector } from "@app/react";
import { activityDetailUrl, operationDetailUrl } from "@app/routes";
import { Navigate, useParams } from "react-router-dom";
import { AppSidebarLayout } from "../layouts";
import { Banner, Box, LoadingSpinner } from "../shared";

export function ActivityByOperationPage() {
  const { operationId = "" } = useParams();

  const loader = useQuery(fetchActivityByOperationId({ operationId }));
  const activity = useSelector((s) =>
    selectFreezerActivityByOperationId(s, { operationId }),
  );

  if (activity.id !== "") {
    return <Navigate to={activityDetailUrl(activity.id)} replace />;
  }

  if (loader.isError) {
    return (
      <AppSidebarLayout>
        <Box>
          <Banner variant="warning">
            We couldn't find an activity for operation {operationId}.{" "}
            <a className="text-indigo" href={operationDetailUrl(operationId)}>
              View the operation
            </a>{" "}
            instead.
          </Banner>
        </Box>
      </AppSidebarLayout>
    );
  }

  return (
    <AppSidebarLayout>
      <Box>
        <div className="flex items-center gap-2 text-sm text-black-500">
          <LoadingSpinner /> Finding the activity for this operation…
        </div>
      </Box>
    </AppSidebarLayout>
  );
}
